/**
 * Financial health levels based on VeraScore
 */
export enum HealthLevel {
  AT_RISK = 'At Risk',
  NEEDS_IMPROVEMENT = 'Needs Improvement',
  FAIR = 'Fair',
  HEALTHY = 'Healthy',
  EXCELLENT = 'Excellent'
}

/**
 * Input data for VeraScore calculation
 */
export interface VeraScoreInputs {
  // Required financial data
  grossIncome: number;
  minimumDebtPayments: number;
  liquidReserves: number;
  monthlyExpenses: number;
  moneyLeftover: number;
  netSavings: number;
  totalOutstandingAdverseDebt: number;
  actualAdverseDebtPayments: number;
  ageOfMostRecentLatePayment: number;
  numberOfLatePayments: number;
}

/**
 * Common structure for factor details
 */
interface FactorDetails {
  ratio: number;
  factor: number;
  health: HealthLevel;
  weight: number;
  weightedScore: number;
}

/**
 * Payment history factor details (no ratio)
 */
interface PaymentHistoryDetails {
  factor: number;
  health: HealthLevel;
  weight: number;
  weightedScore: number;
}

/**
 * Detailed output from VeraScore calculations
 */
export interface VeraScoreDetails {
  veraScore: number;
  healthLevel: HealthLevel;
  
  debtToIncome: FactorDetails;
  liquidReserves: FactorDetails;
  cashFlow: FactorDetails;
  savings: FactorDetails;
  debt: FactorDetails;
  paymentHistory: PaymentHistoryDetails;
} 